export default class AdvancedFiltersViewModel {
    isActive: boolean = false;
    randomSelection: number = 0;
    randomAgentSelection: number = 0;
    tags: string[] = [];
    isUnflaggedNC: boolean = false;
}